<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ 'users.supplierUsers.create.inviteUsers' | translate }}</h3>
    </div>

    <div class="cardContent">
        @if ((suppliers && suppliers.length > 0) || selectedSupplier) {
            <form [formGroup]="newUserForm">
                @if (isShijiUser) {
                    <div class="inputGroup">
                        <span class="label">{{ 'users.supplierUsers.create.company' | translate }}</span>
                        <div class="inputWrapper">
                            <app-form-error [parentForm]="newUserForm" [controlPath]="'supplier'" />
                            <app-typeahead-select
                                formControlName="supplier"
                                class="formControl"
                                [id]="'supplier'"
                                [optionsList]="suppliers"
                                [idKey]="'supplierId'"
                                [labelKey]="'companyName'"
                            />
                        </div>
                    </div>
                }
                <div class="inputGroup labelTop">
                    <label for="emails">{{ (newUserForm.get('contact')?.value ? 'users.email' : 'users.emails') | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="newUserForm" [controlPath]="'emails'" />
                        @if (newUserForm.get('contact')?.value) {
                            <input type="email" id="email" formControlName="emails" />
                        } @else {
                            <textarea
                                id="emails"
                                formControlName="emails"
                                [placeholder]="'users.supplierUsers.create.emailsPlaceholder' | translate"
                            ></textarea>
                        }
                    </div>
                </div>
                <div class="inputGroup">
                    <label [for]="userGroups?.length ? 'userGroup' : undefined">
                        {{ 'users.supplierUsers.create.userGroups' | translate }}
                    </label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="newUserForm" [controlPath]="'userGroup'" />
                        <select [ngClass]="{ noGroup: !userGroups?.length }" [formControlName]="'userGroup'" id="userGroup">
                            @for (group of userGroups; track group) {
                                <option [value]="group.userGroupId">{{ group.name }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="inputGroup">
                    <label for="accessGroup">{{ 'users.supplierUsers.create.accessGroups' | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="newUserForm" [controlPath]="'accessGroup'" />
                        <app-multi-select-input
                            id="accessGroup"
                            formControlName="accessGroup"
                            [optionsList]="accessGroups"
                            [idKey]="'listingAccessId'"
                            [labelKey]="'name'"
                        />
                    </div>
                </div>
                @if (selectedSupplier && !selectedSupplier.hasContact) {
                    <div class="inputGroup">
                        <label for="contact">{{ 'users.supplierUsers.create.companyContact' | translate }}</label>
                        <input type="checkbox" [formControlName]="'contact'" id="contact" />
                    </div>
                }
                @if (selectedSupplier) {
                    <div class="inputGroup">
                        <label for="doNotEmail" class="label">{{ 'users.supplierUsers.create.doNotEmail' | translate }}</label>
                        <input type="checkbox" id="doNotEmail" formControlName="doNotEmail" />
                    </div>
                }
            </form>
        }
    </div>
    <div class="cardFooter">
        <div class="buttonArea">
            <button type="button" class="button primary" (click)="createUser()">
                {{ 'users.supplierUsers.create.invite' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModal()">
                {{ 'generalKeywords.cancel' | translate }}
            </button>
        </div>
    </div>
</div>
